export const NODE_NAME = 'horizontal_rule';
